const QUARTER_NUMBERS = [ 'I', 'II', 'III', 'IV' ];

export const timestampToQuater = ( ts, searchSting ) => {
	const date = new Date( ts * 1000 );
	const quarterIndex = parseInt( date.getMonth() / 4 ) + 1;

	return searchSting ? `${date.getFullYear()}/${QUARTER_NUMBERS[quarterIndex]}` : `${QUARTER_NUMBERS[quarterIndex]}&nbsp;кв. ${date.getFullYear()}`;
};